import React from 'react'
import { CreatedBy } from '@accodeing/gatsby-theme-heimr'
import { Link } from 'gatsby'

import SiteMetadata from 'query/siteMetadata'

import linesDivider from 'images/threeGreenLines01.svg'
import logotype from 'images/logo.svg'
import platVentforetagen from 'images/pvforetagen.svg'
import miljoTag from 'images/SUSA_SvMiljobas.svg'

const Footer = () => {
  const siteMetadata = SiteMetadata()
  return (
    <oma-grid-row fullWidth class='row row--with-top-margin'>
      <footer className='footer'>
        <section className='section section--aligned-with-grid'>
          <div className='footer__top'>
            <oma-social-media-links class='social-media-links'>
              <oma-social-media-link
                class='social-media-link'
                accountid={siteMetadata.facebook}
                type='facebook'
                label='Följ oss på Facebook'
              >
                <i class='fab fa-facebook-f social-media-icon' />
              </oma-social-media-link>

              <oma-social-media-link
                class='social-media-link'
                accountid={siteMetadata.instagram}
                type='instagram'
                label='Följ oss på Instagram'
              >
                <i class='fab fa-instagram social-media-icon' />
              </oma-social-media-link>
            </oma-social-media-links>
            <div className='partners'>
              <img
                className='partner'
                src={platVentforetagen}
                alt='Plåt & ventföretagens logotyp'
              />
              <img
                className='partner'
                src={miljoTag}
                alt='Svensk miljöbas logotyp'
              />
            </div>
          </div>
        </section>
        <div className='footer__divider'>
          <img
            src={linesDivider}
            alt='Tre streck i olika nyanser av grönt som delar upp sidans innehåll'
            className='category-divider'
          />
          <img
            className='footer__logotype'
            src={logotype}
            alt='ECO VS logotyp'
          />
        </div>
        <section className='section section--with-theme-color'>
          <div className='footer__information'>
            <div className='footer__company-details'>
              <div>
                <p className='footer-paragraph'>ECO VS</p>
                <p className='footer-paragraph'>
                  FAKTURAADRESS: {siteMetadata.contactDetails.address.address}
                </p>
                <p className='footer-paragraph'>
                  {siteMetadata.contactDetails.address.zipCode}{' '}
                  {siteMetadata.contactDetails.address.location}
                </p>
              </div>
              <ul className='footer__menu'>
                <li className='footer__link'>
                  <Link to='/#ventilation'>Ventilation</Link>
                </li>
                <li className='footer__link'>
                  <Link to='/#service'>Service</Link>
                </li>
                <li className='footer__link'>
                  <Link to='/#kontakt'>Kontakt</Link>
                </li>
                <li className='footer__link'>
                  <Link to='/#referenser'>Referenser</Link>
                </li>
              </ul>
            </div>
          </div>
          <CreatedBy className='created-by' />
        </section>
      </footer>
    </oma-grid-row>
  )
}

export default Footer
